<template>
  <div>
    <label>{{ $t('Show') }}</label>
    <v-select
      v-model="perPage"
      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
      :options="options"
      :value="value"
      :clearable="false"
      class="per-page-selector d-inline-block ml-50 mr-1"
    />
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  name: 'TableEntries',
  components: {
    vSelect,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: [Object, String, Number, Boolean],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      perPage: '',
    }
  },
  computed: {
    hasValue() {
      return !!this.perPage
    },
  },
  watch: {
    perPage(value) {
      this.$emit('input', value)
    },
    value(val) {
      if (val !== this.perPage) {
        this.perPage = val
      }
    },
  },
  created() {
    if (this.value) {
      this.perPage = this.value
    }
  },
}
</script>

<style lang="scss">
.per-page-selector {
  width: 90px;
}
.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';
</style>
